module.exports = __webpack_public_path__ + "img/zsjg_IOS.3a952833.png";